<script setup>

import MultiSearchDropDown from "@/components/common/input/MultiSearchDropDown.vue";
import {useGetValidatedFields} from "@/composables/common/useGetValidatedFields";
import {computed, inject} from "vue";

const validationViewModel = inject("validationViewModel");

const requiredFieldsList = computed(() => {

  return props.requiredFields
})

const props = defineProps({

  modelValue: {},
  validationModel: '',

  countries: {
    type: Array, default: function () {
      return []
    }
  },

  requiredFields: {
    type: Array, default: function () {
      return []
    }
  }
})

</script>

<template>

  <div class="global-css_horizontal-form-layout-label-top">
    <TextInput
        v-model="modelValue.name"
        :maxLength="50"
        :label-top="true"
        :width="400"
        :required-field="true"
        v-model:validation-fail="validationViewModel[props.validationModel].name"
        :disable="modelValue.newCompanySaved"
        label="Company Name">
    </TextInput>
    <TextInput
        v-model="modelValue.addressLine1"
        :maxLength="50"
        :label-top="true"
        :width="400"
        :required-field="true"
        v-model:validation-fail="validationViewModel[props.validationModel].addressLine1"
        :disable="modelValue.newCompanySaved"
        label="Address Line 1">
    </TextInput>
    <TextInput
        v-model="modelValue.addressLine2"
        :maxLength="50"
        :label-top="true"
        :width="400"
        v-model:validation-fail="validationViewModel[props.validationModel].addressLine2"
        :requiredField="useGetValidatedFields(requiredFieldsList, 'addressLine2' )"
        :disable="modelValue.newCompanySaved"
        label="Address Line 2">
    </TextInput>
    <TextInput
        v-model="modelValue.city"
        :maxLength="50"
        :label-top="true"
        :width="260"
        :disable="modelValue.newCompanySaved"
        label="City">
    </TextInput>
    <TextInput
        v-model="modelValue.postCode"
        :maxLength="10"
        :label-top="true"
        :width="260"
        :disable="modelValue.newCompanySaved"
        label="Post Code / ZIP">
    </TextInput>
    <TextInput
        v-model="modelValue.county"
        :maxLength="50"
        :label-top="true"
        :width="260"
        :disable="modelValue.newCompanySaved"
        label="County / State">
    </TextInput>
    <MultiSearchDropDown
        :key="props.countries"
        v-model="modelValue.country"
        :dataSource="props.countries"
        :allowCustomValue="false"
        :label-top="true"
        :width="260"
        :disable="modelValue.newCompanySaved"
        label="Country"
        :selectPrimitiveValue="true">
    </MultiSearchDropDown>
    <div class="global-flex-layout">
      <TextInput
          v-model="modelValue.vatNumber"
          :maxLength="50"
          :label-top="true"
          :width="260"
          :disable="modelValue.newCompanySaved"
          label="VAT Number">
      </TextInput>
      <slot name="vat-number-flex-content"></slot>
    </div>
    <slot name="keep-contacts"></slot>
  </div>

</template>

<style scoped lang="scss">


</style>
